<template>
  <a-modal
    :title="`${modalTit}：${comDatas.comname}`"
    :visible.sync="isLimitDialogShow"
    :width="isEnglish ? '516px' : '486px'"
    :ok-text="okTxt"
    :cancel-text="cancelTxt"
    class="edit-limit-dialog"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    @ok="submitHandle"
    @cancel="isLimitDialogShow=false"
  >
    <div class="creat-dilog-form">
      <a-form
        ref="editForm"
        :hide-required-mark="true"
        :form="form"
        class="demo-form-inline"
      >
        <a-form-item
          :label="`${receiveTit}：`"
          :label-col="{ span: isEnglish ? 7: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-decorator="decorators.transferuserid"
            show-search
            :filter-option="false"
            :not-found-content="emptyTip"
            :placeholder="place"
            @search="handleSearch"
            @change="getVal"
            @blur="handleFocus"
          >
            <a-select-option
              v-for="(item, index) in options"
              :key="index"
              :label="`${item.truename} ${item.mobile}`"
              :value="item.userid"
              :title="item.truename"
            >
              {{ item.truename }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <template v-if="!$isDingDing">
          <a-form-item
            :label="`${mobileTit}：`"
            :label-col="{ span: isEnglish ? 7: 5}"
            :wrapper-col="{ span: 16 }"
          >
            <a-input
              v-decorator="['mobile', { rules: [
                { required: true, message: telNeed, trigger: 'blur' }
              ] ,initialValue: mobile}]"
              :disabled="true"
              type="text"
            />
          </a-form-item>
          <!-- <captcha-input
            :label="imgValidTit"
            :label-col="{ span: isEnglish ? 7: 5 }"
            :wrapper-col="{ span: 16 }"
          /> -->
          <a-form-item
            :label="`${validTit}：`"
            :label-col="{ span: isEnglish ? 7: 5 }"
            :wrapper-col="{ span: 16 }"
            class="password-box"
          >
            <a-input
              v-decorator="decorators.checkcode"
              type="text"
              :placeholder="validPlaceholder"
            />
            <get-code
              class="find-pwd-link ml-16"
              :is-disabled="isDisabled"
              type="14"
              :mobile="editForm.mobile"
              @getRes="getRes"
            />
          </a-form-item>
        </template>
      </a-form>
    </div>
    <!-- <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="isLimitDialogShow=false">取消</el-button>
      <el-button
        type="primary"
        :disabled="submiting"
        @click="submitHandle('editForm')"
      >转让</el-button>
    </span> -->
  </a-modal>
</template>
<script>
import { cloneDeep } from 'lodash'
import GetCode from '@/components/pc/GetCode.vue'
import { mapActions, mapState } from 'vuex'
import { getLang } from '@/lib/storage'
// import CaptchaInput from '@/components/pc/CaptchaInput.vue'

export default {
  components: {
    GetCode
  },
  props: {
    comDatas: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isDisabled: false,
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      value: '',
      editForm: {
        mobile: ''
      },
      mobile: ''
    }
  },
  computed: {
    ...mapState('organization/org', ['baseinfoData', 'orgSelectDatas', 'decorators']),
    options () {
      let arr2 = cloneDeep(this.orgSelectDatas)
      arr2 = arr2.map(ele => {
        if (ele.mobile) {
          let str = ele.mobile
          ele.mobile = str.substring(0, 3) + '****' + str.substring(7, 11)
        }
        return ele
      })
      return arr2
    },
    validPlaceholder () {
      return this.$t('message["824"]')
    },
    accountPlaceholder () {
      return this.$t('message["842"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    telNeed () {
      return this.$t('message["1115"]')
    },
    mobileTit () {
      return this.$t('message["1112"]')
    },
    receiveTit () {
      return this.$t('message["1121"]')
    },
    validTit () {
      return this.$t('message["1433"]')
    },
    imgValidTit () {
      return '图片验证码'
    },
    emptyTip () {
      return this.$t('message["1551"]')
    },
    modalTit () {
      return this.$t('message["1644"]')
    },
    okTxt () {
      return this.$t('message["1641"]')
    },
    place () {
      return this.$isDingDing ? this.$t('message["844"]') : this.$t('message["842"]')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  watch: {
    transferuserid (val) {
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  mounted () {
  },
  methods: {
    ...mapActions('organization/org', ['fetchOrgSelectDatas', 'ajaxSecondTranOrg']),
    getLang,
    changeVisible2 (isShow) {
      this.isLimitDialogShow = isShow
    },
    submitHandle (formName) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const formDatas = !this.$isDingDing ? Object.assign(values, { cid: this.comDatas.cid, mobile: this.editForm.mobile }) : Object.assign(values, { cid: this.comDatas.cid })
          const chain = await this.ajaxSecondTranOrg({ cid: this.comDatas.cid })
          chain.params(formDatas)
            .onSuccess(() => {
              this.isLimitDialogShow = false
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    getRes (payload) {
      // this.inviteLogin.checkuserid = payload.checkuserid
    },
    async handleSearch (val) {
      const chain = await this.fetchOrgSelectDatas()
      chain.params({ cid: this.comDatas.cid, keywords: val })
        .fetch()
    },
    async handleFocus () {
      const chain = await this.fetchOrgSelectDatas()
      chain.params({ cid: this.comDatas.cid, keywords: '' })
        .fetch()
    },
    getVal (val) {
      this.editForm.mobile = ''
      if (!this.$isDingDing) {
        this.options.forEach((ele, index) => {
          if (ele.userid * 1 === val) {
            // this.mobile = ele.mobile
            this.form.setFieldsValue({ mobile: ele.mobile })
            this.editForm.mobile = this.orgSelectDatas[index].mobile
          }
        })
      }
      // debugger
      // for (let i = 0; i++; i < this.orgSelectDatas.length) {

      //   if (this.orgSelectDatas[i].userid * 1 === val) {
      //     this.editForm.mobile = this.orgSelectDatas[i].mobile
      //     return false
      //   }
      //   console.log(this.editForm.mobile)
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
.select-list-item {
  .select-list-item {
    float: left;
  }

  .select-list-mobile {
    float: right;
  }
}
.password-box::v-deep {
    position: relative;

    .find-pwd-link {
        right: 0;
        top: -7px;
        position: absolute;

      button {
        background: none;
        border: 0;
        color: #5077aa;
        padding: 0;
      }

      .is-disabled {
        color: #c0c4df;
        background: none;
      }
      em {
        margin-right: 12px;
      }
    }
  }
</style>
